import styled from 'styled-components'
import media from 'styled-media-query'

import { customMedia } from '../../../../../utils/breakpoints'

export const ContainerMenuDesktop = styled.div`
  display: flex;
`

export const MenuDesktop = styled.ul`
  display: flex;
  align-items: center;
  height: 64px;
  margin: 0;
  padding-left: 8%;

  ${customMedia.lessThan('md')`
    padding: 0 7%;
    display: none;
  `}
`
